import Bold from '@tiptap/extension-bold';
import BulletList from '@tiptap/extension-bullet-list';
import Code from '@tiptap/extension-code';
import CodeBlock from '@tiptap/extension-code-block';
import { Color } from '@tiptap/extension-color';
import Document from '@tiptap/extension-document';
import Focus from '@tiptap/extension-focus';
import Gapcursor from '@tiptap/extension-gapcursor';
import HardBreak from '@tiptap/extension-hard-break';
import History from '@tiptap/extension-history';
import Italic from '@tiptap/extension-italic';
import OrderedList from '@tiptap/extension-ordered-list';
import Paragraph from '@tiptap/extension-paragraph';
import Placeholder from '@tiptap/extension-placeholder';
import Strike from '@tiptap/extension-strike';
import { Subscript } from '@tiptap/extension-subscript';
import { Superscript } from '@tiptap/extension-superscript';
import Text from '@tiptap/extension-text';
import TextAlign from '@tiptap/extension-text-align';
import TextStyle from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';
import type { EditorFormats } from '../data/.types/editorFormats.ts';
import CustomHeading from './heading.ts';
import { Link } from './link.ts';
import CustomListItem from './listItem.ts';
import TableFormats from './tables.ts';

const extensions = [
  Text,
  Document,
  History,
  Color,
  Link,
  Paragraph,
  TextStyle,
  Underline,
  BulletList,
  OrderedList,
  Bold,
  Italic,
  Strike,
  Superscript,
  Subscript,
  Code,
  CodeBlock,
  TextAlign.configure({
    types: ['heading', 'paragraph'],
  }),
  ...TableFormats,
  Focus.configure({
    className: 'has-focus',
    mode: 'all',
  }),
  Placeholder.configure({
    placeholder: 'Your text goes here',
  }),
  Gapcursor,
  HardBreak,
];

export const buildExtensions = (editorFormats: EditorFormats = {}) => {
  const builtExtensions = [...extensions];

  const customHeading = CustomHeading(editorFormats?.heading || {});
  if (!builtExtensions.find((extension) => extension.name === 'heading')) {
    builtExtensions.push(customHeading);
  }

  const customListItem = CustomListItem(editorFormats?.list || {});
  if (!builtExtensions.find((extension) => extension.name === 'listItem')) {
    builtExtensions.push(customListItem);
  }

  return builtExtensions;
};
